/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifNotAuthenticated } from '../routeValidation';
import AuthenticationLayout from '@/views/Layout/AuthenticationLayout.vue';
import { ROUTES } from './routes';

const { FORGOT_PASSWORD, RESET_PASSWORD, } = ROUTES;
const ForgotPassword = () =>
  import(/* webpackChunkName: "ForgotPassword" */ '@/views/ForgotPassword/SendPasswordInstructions.vue');
const ResetPassword = () =>
  import(/* webpackChunkName: "ResetPassword" */ '@/views/ForgotPassword/ResetPassword.vue');

export default {
  path: FORGOT_PASSWORD.route,
  component: AuthenticationLayout,
  beforeEnter: ifNotAuthenticated,
  children: [
    {
      path: FORGOT_PASSWORD.route,
      name: FORGOT_PASSWORD.name,
      component: ForgotPassword,
    },
    {
      path: RESET_PASSWORD.route,
      name: RESET_PASSWORD.name,
      component: ResetPassword,
    }
  ],
};
